export default __webpack_public_path__ + "static/media/adWhite.7188f4ca.svg";